import { DataKey, MetricGroup } from 'types'

export function getMetricCodeByName(data: any[], metricName: string): string {
  for (const item of data) {
    if (item[Object.keys(item)[0]] === metricName) {
      return Object.keys(item)[0]
    }
  }
  return ''
}
export function getMetricNameByCode(data: any[], metricCode: string): string {
  for (const item of data) {
    if (item.hasOwnProperty(metricCode)) {
      return item[metricCode]
    }
  }
  return ''
}
export function getIsNoDataByMetricName(data: any[], metricName: string) {
  for (const item of data) {
    if (Object.values(item).includes(metricName)) {
      return item.isNoData
    }
  }
  return false
}
export function getMetricByKey(
  allMetrics: Record<string, string | number>[],
  key: string,
): string | number | undefined {
  const metricInfo = allMetrics.find((info) => key in info)
  return metricInfo?.[key]
}
export function getMetricObjByKey(allMetrics: Record<string, string | number>[], key: string): any {
  const metricInfo = allMetrics.find((info) => key in info)
  return metricInfo
}
export const getMetricList = (metricGroups: MetricGroup[], metricKey: DataKey, currentMetricValue: string) => {
  const metricList = metricGroups.find((group) => group.metricGroupNameDatakey === metricKey)?.metricList
  const metricListWithValue = !!metricList && (metricList as any)[currentMetricValue]
  return metricListWithValue
}

export const getMetricNameByShortNameRaw = (metricGroupData: any, metricShortNameRaw: string) => {
  if (!metricGroupData.length) return ''
  let name = ''
  metricGroupData.forEach((group: any) => {
    group?.metrics?.forEach((metric: any) => {
      if (metric.shortname_raw === metricShortNameRaw) {
        name = metric.metricName
      }
    })
  })
  return name
}
